import { makeStyles } from '@material-ui/core/styles';
import { ERebrandingColors } from 'helpers/constants';

const styleOptions = {
  minHeight: '38px',
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',

  margin: 0,
  padding: '8px 0',
  transition: 'all .2s ease-in-out',
  '& > span': {
    color: '#fff',
    fontFamily: 'inherit',
    fontSize: '14px',
    lineHeight: '100%',
    fontWeight: 400,
    '&:first-child': {
      opacity: 0,
      visibility: 'hidden',
      display: 'none',
    },
  },
  '&:first-child': { borderRadius: '5px 0 0 5px' },
  '&:last-child': { borderRadius: '0 5px 5px 0' },
  '&:hover': { backgroundColor: ERebrandingColors.MAIN },
};

const styles = makeStyles((theme) => ({
  formControl: {
    display: 'block',
    fontFamily: 'inherit',
  },
  boxSubtitle: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: 'inherit',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '150%',
  },
  optionsGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexDirection: 'row',
    margin: '16px 0',
  },
  options: {
    ...styleOptions,
    backgroundColor: theme.palette.grey[300],
    '&.--selected': {
      backgroundColor: ERebrandingColors.MAIN,
    },
    '&.--disabled': {
      '&:hover': { backgroundColor: theme.palette.grey[300] },
    },
  },
}));

export default styles;
